import { combineReducers } from 'redux'

import { usuario } from './usuario/reducer'

export const reducers = combineReducers({
  usuario
})
